import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Dropdown from "components/forms/inputs/dropdown";
import { OptionInterface } from "components/forms/inputs/dropdown.styles";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import Modal from "components/layout/modal";
import { showError, showSuccess } from "lib/notification";
import { Admin } from "models/admin";
import { ListAdmin } from "models/list-admin";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { adminDoPostListAdmin } from "services/admin/list-admin";
import * as yup from "yup";

interface ListAdminAddModalProps {
  listUuid: string;
  admins: Admin[];
  listAdmins: ListAdmin[];
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

const ListAdminAddModal: FunctionComponent<ListAdminAddModalProps> = ({
  listUuid,
  admins,
  listAdmins,
  onUpdate,
  onClose,
}) => {
  const validAdmins = admins.filter((admin) => {
    if (listAdmins.find((la) => la.admin_uuid === admin.uuid)) {
      return false;
    }
    return true;
  });

  const schema = yup
    .object({
      admin_uuid: yup
        .string()
        .validateRequired()
        .validateOneOf(validAdmins.map((va) => va.uuid)),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { admin_uuid: validAdmins[0].uuid },
  });

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton },
  ];

  const handleSubmit = async (values: any) => {
    const { admin_uuid } = values;
    // save
    try {
      adminDoPostListAdmin(listUuid, admin_uuid);
      showSuccess("Pääsyoikeus lisätty.");
    } catch (err) {
      showError("Pääsyoikeutta ei voitu lisätä.");
    }

    // update
    onUpdate();

    // close
    onClose();
  };

  const options: OptionInterface[] = validAdmins.map((va) => {
    return {
      value: va.uuid,
      text: `${va.firstname} ${va.lastname}`,
    };
  });

  return (
    <Modal title="Lisää pääsyoikeus">
      <Form methods={methods} onSubmit={handleSubmit}>
        <Grid>
          <Row>
            <Col>
              <Dropdown
                name="admin_uuid"
                label="Ylläpitäjä"
                options={options}
              />
            </Col>
          </Row>
        </Grid>
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default ListAdminAddModal;
